export const DOMAIN_COLORS: Record<string, { bg: string; text: string; border: string }> = {
  Fury: { bg: "#2a1010", text: "#d06060", border: "#6a2020" },
  Calm: { bg: "#0e2018", text: "#4dab70", border: "#1e5030" },
  Mind: { bg: "#0e1628", text: "#6080d0", border: "#1e3060" },
  Body: { bg: "#201408", text: "#c08040", border: "#604020" },
  Chaos: { bg: "#1a1028", text: "#9070d0", border: "#402868" },
  Order: { bg: "#0c1e1c", text: "#40b0a8", border: "#1a5050" },
  Colorless: { bg: "#181818", text: "#909090", border: "#404040" },
};

export const DOMAINS = ["Fury", "Calm", "Mind", "Body", "Chaos", "Order"] as const;

export function baseLegendKey(name: string): string {
  return name.replace(/\s*\([^)]*\)\s*$/u, "").trim().toLowerCase();
}
